import { render, staticRenderFns } from "./fileDownloadPage.vue?vue&type=template&id=639492f4&scoped=true"
import script from "./fileDownloadPage.vue?vue&type=script&lang=js"
export * from "./fileDownloadPage.vue?vue&type=script&lang=js"
import style0 from "./fileDownloadPage.vue?vue&type=style&index=0&id=639492f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639492f4",
  null
  
)

export default component.exports